import { Suspense } from 'react';
import {
  Link,
  Page,
  PageBody,
  PageHeader,
  PageHeaderDescription,
  PageHeaderTitle,
  PageLoader,
} from '@customerio/pluma-components/react';
import { DocumentTitle } from '@/components/page/document-title';
import { useLocation } from '@tanstack/react-router';
import { getWorkspaceIdFromUrl } from '@/utils/workspace-id';
import { CreateReportingWebhook } from './form/create-reporting-webhook';
import { REPORTING_WEBHOOKS_DOCS_URL, useNewReportingWebhookBreadcrumbs } from './hooks';

export default function NewPage() {
  // Reactive read: on `/workspaces/last` the id resolves a beat later, and a `window.location`
  // read would never see it land.
  const { pathname } = useLocation();
  const workspaceId = Number(getWorkspaceIdFromUrl(pathname));

  useNewReportingWebhookBreadcrumbs(String(workspaceId));

  if (!Number.isInteger(workspaceId) || workspaceId <= 0) {
    return <PageLoader />;
  }

  return (
    <>
      <DocumentTitle title="Add Reporting Webhook" />
      <Page>
        <PageHeader>
          <PageHeaderTitle>Add Reporting Webhook</PageHeaderTitle>
          <PageHeaderDescription>
            Details on the format and specific webhooks we deliver are available in{' '}
            <Link href={REPORTING_WEBHOOKS_DOCS_URL} variant="secondary" isExternal>
              our documentation
            </Link>
            .
          </PageHeaderDescription>
        </PageHeader>
        <PageBody>
          <Suspense fallback={<PageLoader />}>
            <CreateReportingWebhook workspaceId={workspaceId} />
          </Suspense>
        </PageBody>
      </Page>
    </>
  );
}
